export const noPropertyOrNull = (object, prop) => {
  return !Object.hasOwn(object, prop) || object[prop] === null;
};

export const hasErrors = (object) => {
  return Object.keys(object)
    .map((prop) => noPropertyOrNull(object, prop))
    .every(Boolean);
};
